import React, { useEffect, useState } from 'react';
import { Form, notification, SelectProps, Select } from 'antd';
import Button from '/react4xp/mixins/ui/button/button';
import { Space } from 'antd';
import { IShownComponents } from '../express-help.types';
import BtnReturnBack from '/react4xp/parts/express-help/BtnReturnBack';
import TextArea from 'antd/es/input/TextArea';
import {getRandomSecure} from "mixins/helpers";
import {createAnswer, getQuestionList, getResultTypeList} from "/react4xp/parts/express-help/actions";

const CreateAnswer = (props: any) => {
    const [results, setResults] = useState<SelectProps['options']>([]);
    const [questions, setQuestions] = useState<SelectProps['options']>([]);
    const [isSaving, setIsSaving] = useState(false);

    const [form] = Form.useForm();

    const onFinish = async (values: any) => {
        setIsSaving(true);

        values.username = props.user.login;
        values.questionId = props.showObject.idOfQuestion;
        values.externalAnswerId = Number.parseInt('' + getRandomSecure() * 100000000);

        createAnswer(values).then(() => {
            notification['info']({
                message: 'Ответ добавлен!',
            });

            form.resetFields();
            onReturnBackHandler();
        }).finally(
            () => setIsSaving(false)
        );
    };

    const onReturnBackHandler = () => {
        const nextPageParameter: IShownComponents = {
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: false,
            answerPageShown: false,
            editMode: props.showObject.editMode,
            pollItemPageShown: false,
            questionsAnswersPageShown: true,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            idOfQuestion: props.showObject.idOfQuestion,
        };

        if (nextPageParameter.editMode) {
            nextPageParameter.questionPageShown = true;
            nextPageParameter.questionsAnswersPageShown = false;
        }

        props.showNext(nextPageParameter);
    };

    useEffect(() => {
        getQuestionList().then((response) => {
            setQuestions(response.data);
        });

        getResultTypeList().then((response) => {
            setResults(response.data);
        });
    }, []);

    return (
        <div className="poll-screen">
            <BtnReturnBack handler={onReturnBackHandler} />

            <h4 className="my-3">Добавить ответ</h4>

            <Form
                className="my-3"
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    name="answerKk"
                    label="Ответ на казахском языке"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <TextArea placeholder="Введите"/>
                </Form.Item>
                <Form.Item
                    name="answerRu"
                    label="Ответ на русском языке"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <TextArea
                        placeholder="Введите"
                        maxLength={2400}
                    />
                </Form.Item>
                <Form.Item
                    name="answerEn"
                    label="Ответ на английском языке"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <TextArea
                        placeholder="Введите"
                        maxLength={2400}
                    />
                </Form.Item>
                <Form.Item
                    name={'resultIds'}
                    label={'Результаты'}
                >
                    <Select
                        mode="multiple"
                        showSearch
                        placeholder={'Выберите'}
                        notFoundContent={<p>не найдено</p>}
                        options={(results || []).map((d) => ({
                            value: d.id,
                            label: d.resultRu,
                        }))}
                    />
                </Form.Item>
                <Form.Item
                    name="nextQuestionId"
                    label="Добавочный вопрос"
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select
                        showSearch
                        placeholder={'Выберите'}
                        showArrow={false}
                        filterOption={false}
                        notFoundContent={<p>не найдено</p>}
                        options={(questions || []).map((d) => ({
                            value: d.id,
                            label: d.questionRu,
                        }))}
                    />
                </Form.Item>

                <Space wrap>
                    <Button onClick={onReturnBackHandler}>
                        Отменить
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        color="gold"
                        loading={isSaving}
                    >
                        Сохранить
                    </Button>
                </Space>
            </Form>
        </div>
    );
};

export default CreateAnswer;
